'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ajax = void 0;
const $ = require("jquery");
class Ajax {
    constructor() {
        $('.trigGoodPhoto').on('click', (e) => {
            const user_id = $(e.currentTarget).data('user');
            const select_photo_id = $(e.currentTarget).data('photo-id');
            const D = { user_id: user_id, select_photo_id: select_photo_id };
            const token = $('meta[name="csrf-token"]').attr('content');
            $.ajax({
                headers: { 'X-CSRF-TOKEN': token },
                type: 'post',
                url: '/ajax/select_vote',
                dataType: 'json',
                data: D,
            }).done((res) => {
                $(`.paramVotePhoto[data-photo-id=${select_photo_id}]`).attr('data-is-select', 'true');
                $('.bulletThankYou').fadeIn('slow');
                if (res === true) {
                    console.log('既に登録されています');
                    $('.trigGoodPhoto ').attr('data-is-vote', 'true');
                }
                else {
                    console.log('投票ありがとうございます');
                    $('.trigGoodPhoto ').attr('data-is-vote', 'true');
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                /*
                // 通信失敗時の処理
                console.log("ajax通信に失敗しました");
                console.log("jqXHR          : " + jqXHR.status); // HTTPステータスが取得
                console.log("textStatus     : " + textStatus);    // タイムアウト、パースエラー
                console.log("errorThrown    : " + errorThrown.message); // 例外情報
                 */
            });
        });
    }
}
exports.Ajax = Ajax;
exports.default = Ajax;
